export default import.meta.ROLLUP_FILE_URL_CMj47Xz9;